import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import store from "@/store";
// Initialize Firebase, copy this from the cloud console
// Or use mine :)
// Initialize Firebase
var config = {
  apiKey: "AIzaSyDperBGO-w4ZfLItxVXRkBOo_fXt7UZ6HI",
  authDomain: "soundslides-services.firebaseapp.com",
  databaseURL: "https://soundslides-services.firebaseio.com",
  projectId: "soundslides-services",
  storageBucket: "soundslides-services.appspot.com",
  messagingSenderId: "692228897432"
};
const firebaseApp = firebase.initializeApp(config);

//firebase.initializeApp(config);

// When a user logs in or out, save that in the store
firebase.auth().onAuthStateChanged(user => {
  console.log("Logged in as:", user);
  // Pass to VueX?
  store.commit("setUser", user);
});

export const db = firebaseApp.firestore();
